import { Reveal } from "./Reveal";

const PARAS = [
  "My first year in court, I spent more time at the photocopier than in front of a judge. I assumed the fix was to specialise, so I went to London for an LLM in IP Laws from Queen Mary University London.",
  "What actually changed things was a side project. At qLegal I worked on a legal product brief for the Mayor of London's office in collaboration with Ropes & Gray LLP, building working prototypes that made law usable for people who couldn't afford lawyers. It was the first time I'd fixed a legal problem instead of arguing about one, and I didn't want to go back.",
  "Two years at SeedLegals showed me the same thing at scale: 100+ founders through live funding rounds, where software did the legal work and lawyers handled what was left. I spearheaded one of their first AI initiatives in early 2023.",
];

const Intro = ({ onNavigate }) => (
  <section className="wrap intro-section" style={{ padding: "40px 40px 96px" }} data-testid="intro-section">
    <div style={{ display: "flex", gap: 72, flexWrap: "wrap" }} className="intro-row">
      <Reveal style={{}} className="intro-label">
        <div className="intro-label-col" style={{ width: 220, fontSize: "var(--micro-cap-size)", letterSpacing: "var(--micro-cap-ls)", lineHeight: "var(--micro-cap-lh)", textTransform: "uppercase", fontWeight: 400, color: "var(--ink-mute)", paddingTop: 8 }}>
          First, an introduction
        </div>
      </Reveal>
      <div style={{ flex: "1 1 520px", minWidth: 0, maxWidth: 660, display: "flex", flexDirection: "column", gap: 20 }}>
        {PARAS.map((p, i) => (
          <Reveal key={i} delay={i * 0.08}>
            <p style={{ margin: 0, fontSize: "var(--body-lg-size)", lineHeight: 1.7, fontWeight: "var(--weight-thin)", color: "var(--ink-secondary)" }}>{p}</p>
          </Reveal>
        ))}
        <Reveal delay={0.24}>
          <p style={{ margin: 0, fontSize: "var(--body-lg-size)", lineHeight: 1.7, fontWeight: 400, color: "var(--ink)" }}>
            Then I came home to build the Indian version.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Intro;
